var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.dataLesson.typeUploadExcercise == 4 || _vm.dataLesson.typeUploadExcercise == 6)?_c('ContentExcerciseNotScore_Word_PDF'):_vm._e(),(_vm.dataLesson.typeUploadExcercise == 2)?_c('ContentExcerciseNotScore_Bank'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }